<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Hari Libur</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-dialog v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" v-if="$store.state.currentPagePriv.create">
                                Add
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container>
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <v-row>
                                            <v-col cols="6">
                                                <span>Tanggal</span>
                                                <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs}">
                                                        <v-text-field v-model="editedItem.date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="editedItem.date"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <span>Keterangan</span>
                                                <v-text-field v-model="editedItem.description" outlined dense hide-details="auto" :rules="reqRule" />
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="close">
                                    Cancel
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="save">
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="body-1 text-center">Anda akan menghapus data ini ?</v-card-title>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialogDetail" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">Detail Hari Libur</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="font-weight-bold">Tanggal</span>
                                            <v-text-field v-model="viewedItem.date" filled rounded dense hide-details="auto" readonly />
                                        </v-col>
                                        <v-col cols="12">
                                            <span class="font-weight-bold">Keterangan</span>
                                            <v-textarea v-model="viewedItem.description" filled rounded dense hide-details="auto" readonly rows="3" />
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDetail">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewDetail(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon> 
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            dialogDetail: false,
            headers: [
                { text: 'Tanggal', value: 'date' },
                { text: 'Keterangan', value: 'description', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            viewedItem: {},
            reqRule: [v => !!v || 'Harus diisi!'],
            valid: true,
            dateMenu: false,
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'Tambah Hari Libur' : 'Edit Hari Libur'
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            dialogDelete(val) {
                val || this.closeDelete();
            },
            dialogDetail(val) {
                val || this.closeDetail();
            },
        },

        created() {
            this.initialize();
        },

        methods: {
            async initialize() {
                let response = await this.$store.dispatch('holiday/getObjs')
                if (response.data.status=='success') this.items = response.data.data
            },

            viewDetail(item) {
                this.viewedItem = Object.assign({}, item);
                this.dialogDetail = true;
            },

            closeDetail() {
                this.dialogDetail = false;
                this.$nextTick(() => {
                    this.viewedItem = {};
                });
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                this.editedIndex = this.items.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialogDelete = true;
            },

            async deleteItemConfirm() {
                let url = this.$store.state.config.apiHost + "holidays/" + this.editedItem.id;
                let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}});
                if (response.data.status=='success') this.items.splice(this.editedIndex, 1);
                this.closeDelete();
            },

            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
                this.resetForm();
            },
            closeDelete() {
                this.dialogDelete = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
                this.resetForm();
            },

            async save() {
                await this.$refs.form.validate();
                if (!this.valid) return;

                if (this.editedIndex > -1) {
                    let url = this.$store.state.config.apiHost + "holidays/" + this.editedItem.id;
                    let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}});
                    if (response.data.status=='success') Object.assign(this.items[this.editedIndex], this.editedItem);
                    this.close();
                    this.initialize();
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Hari Libur berhasil diupdate'});
                } else {
                    try {
                        let url = this.$store.state.config.apiHost + "holidays"
                        let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                        if (response.data.status=='success') this.items.push(this.editedItem)
                        this.close()
                        this.initialize()
                        this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Hari Libur berhasil ditambahkan'})
                    }
                    catch (err) {
                        const keyword = 'duplicate key'
                        if (err.response.data.message.search(keyword) > -1){
                            return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
                        }
                        else {
                            return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
                        }
                    }
                }
            },

            resetForm() {
                this.$refs.form.reset();
            }
        }
    }
</script>